import { convertCultureToRef } from '@/utils/common-util';

const SUPPORTED_SHORT_LANGS = ['id', 'vn', 'ch', 'th', 'cs', 'zhcn', 'ko', 'jp'] as const;

const FALLBACK_SUFFIX = 'en';

const SLIDER_PATH_PREFIX = '/images/promotion-activity-modal/correct-score-adj-slider/correct-score_';
const BANNER_PATH_PREFIX = '/images/promotion-activity-modal/correct-score-banner/correct-score-640x200_';

function resolveSuffix(locale: string): string {
	const shortLang = convertCultureToRef(locale ?? 'en-US');
	if (!SUPPORTED_SHORT_LANGS.includes(shortLang as (typeof SUPPORTED_SHORT_LANGS)[number])) {
		return FALLBACK_SUFFIX;
	}
	return shortLang === 'zhcn' ? 'cs' : shortLang;
}

/**
 * Correct-score spread promotion static assets (home banner + activity modal KV).
 * Paths match public files under `promotion-activity-modal/correct-score-*`.
 */
export const correctScoreSpreadAssetService = {
	fallbackSuffix: FALLBACK_SUFFIX,

	/** Popup / modal KV (`correct-score-{suffix}.png`). */
	getAdjSliderImageSrc(locale: string): string {
		return `${SLIDER_PATH_PREFIX}${resolveSuffix(locale)}.png`;
	},

	getAdjSliderImageSrcForSuffix(suffix: string): string {
		return `${SLIDER_PATH_PREFIX}${suffix}.png`;
	},

	/** Home carousel (`correct-score-640x200-{suffix}.jpg`). */
	getHomeBannerImageSrc(locale: string): string {
		return `${BANNER_PATH_PREFIX}${resolveSuffix(locale)}.jpg`;
	},

	getHomeBannerImageSrcForSuffix(suffix: string): string {
		return `${BANNER_PATH_PREFIX}${suffix}.jpg`;
	},
};
